// @flow
import * as React from 'react';

import { Menu, MenuIcon, MenuItem } from '../menu';

import { FormattedMessage } from 'react-intl';
import generalIcons from '~/core/constants/icons/general-svg';
import interlaceItems from '../interlace-items';
import type { MenuInsertions } from '~/core/types';
import messages from '~/core/i18n/components/bulbs/intl';
import { noop } from 'lodash/fp';
import { StyledSpan } from '../styles';

type Props = {
    toggleDimmer: noop,
    isOn: boolean,
    additionalItems?: MenuInsertions
};

const PickerMenu = ({ toggleDimmer, isOn, additionalItems = [] }: Props) => {
    const defaultItems = [
        <MenuItem enabled={isOn} key="pickerDimmer" onClick={isOn && toggleDimmer}>
            <MenuIcon type={generalIcons.DIMMER} />
            <FormattedMessage {...messages.pickerDimmer}>
                {message => <StyledSpan>{message}</StyledSpan>}
            </FormattedMessage>
        </MenuItem>
    ];

    return <Menu>{interlaceItems(defaultItems, additionalItems)}</Menu>;
};

export default PickerMenu;



// WEBPACK FOOTER //
// ./src/components/bulbs/tuneablelight/picker-menu.js